import AllocationMis from './components/AllocationMis';

const AllocationMisMain = () => (
  <div>
    <div
      style={{
        display: 'flex',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        height: '100%',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <AllocationMis />
    </div>
  </div>
);

export default AllocationMisMain;
